module.exports = __webpack_public_path__ + "static/media/video-small.6b128d2f.mp4";